import React from 'react';
import { CustomButton } from '../../../../../../components/Button/Button';

const EditorActions = ({ handleSave, handleCancel, isDisable, isMobile }) => {
  return (
    <div 
      className="text-editor-btn-div d-flex"
      style={{ marginBottom: isMobile ? "12px" : "" }}>
      <CustomButton
        onClick={handleSave}
        className="text-editor-btn1"
        variant="contained"
        disabled={isDisable}>
        <div className="text-editor-btn-content">Save</div>
      </CustomButton>
      <CustomButton
        onClick={handleCancel}
        className="text-editor-btn2"
        variant="outlined">
        <div className="text-editor-btn-content">Cancel</div>
      </CustomButton>
    </div>
  );
};

export default EditorActions; 